/**
 * Environment configuration - single source of truth for environment detection
 * 
 * isLocal: true when running locally (npm start OR local Docker)
 *   - Use for: API routing, logging, debug features, dev-only UI
 * 
 * For production Docker builds, pass: --build-arg REACT_APP_IS_LOCAL_DOCKER=false
 */

// Local development via npm start
const isLocalDev = process.env.NODE_ENV === "development";

// Local Docker container (REACT_APP_IS_LOCAL_DOCKER defaults to "true" in Dockerfile)
const isLocalDocker = process.env.REACT_APP_IS_LOCAL_DOCKER === "true";

// Combined: true if either local dev OR local Docker
export const isLocal = isLocalDev || isLocalDocker;
export const enableInternalFleetTools = isLocal;

// API base URL: localhost for local environments, configured URL for deployed
export const API_BASE_URL = isLocal
  ? 'http://localhost:8000'
  : process.env.REACT_APP_ETRUCK_API_BASE_URL;

export const TURNSTILE_SITE_KEY =
  process.env.REACT_APP_TURNSTILE_SITE_KEY || "0x4AAAAAAEQT_lH1XIlNGU9F";
